import { get, set, memoize, omit } from 'lodash';
import { Map, List, Iterable } from 'immutable';

export const reviver = (key, value) => {
  return Iterable.isIndexed(value)
    ? List(value)
    : Map(value).filter((v) => v != null);
};

export const isImmutable = Iterable.isIterable;

export const arrayKey = memoize((key) => {
  if (typeof key === 'string') {
    return key.split('.');
  }

  return key;
});

export function flatten(obj) {
  return flattenRecursive(obj);
}

function flattenRecursive(obj, prefix) {
  return Object.keys(obj).reduce((result, key) => {
    const value = get(obj, key);
    const newKey = prefix ? [...prefix, key] : [key];
    const newKeyString = newKey.join('.');

    if (value == null) {
      return {
        ...result,
        [newKeyString]: null,
      };
    }

    if (typeof value === 'object') {
      return omit(
        {
          ...result,
          ...flattenRecursive(value, newKey),
        },
        [prefix]
      );
    } else {
      return {
        ...result,
        [newKeyString]: value,
      };
    }
  }, {});
}

export function unflatten(obj) {
  return Object.keys(obj).reduce((result, key) => {
    const value = get(obj, key);

    if (value !== undefined) set(result, key, value);

    return result;
  }, {});
}

export function stringKey(key) {
  return key instanceof Array ? key.join('.') : key;
}
